// extracted by mini-css-extract-plugin
export var scrollArea = "_nz-0";